// // import React, { useState } from "react";
// // import "./FolderGallery.css";

// // /* IMAGES */
// // import img1 from "../images/img13.jpg";
// // import img2 from "../images/img14.jpg";
// // import img3 from "../images/img65.jpg";
// // import img4 from "../images/img68.jpg";
// // import img5 from "../images/img69.jpg";
// // import img6 from "../images/new19.jpg";
// // import img7 from "../images/new20.jpg";
// // import img8 from "../images/img17.jpg";
// // import img9 from "../images/new21.jpg";
// // import img10 from "../images/new7.jpg";
// // import img11 from "../images/new8.jpg";
// // import img12 from "../images/new9.jpg";
// // import img13 from "../images/new10.jpg";
// // import img14 from "../images/new11.jpg";
// // import img15 from "../images/new12.jpg";
// // import img16 from "../images/img1.jpg";
// // import img17 from "../images/img2.jpg";
// // import img18 from "../images/img3.jpg";
// // import img19 from "../images/img4.jpg";
// // import img20 from "../images/img5.jpg";
// // import img21 from "../images/img25.jpg";
// // import img22 from "../images/img26.jpg";
// // import img23 from "../images/img60.jpg";
// // import img24 from "../images/img61.jpg";
// // import img25 from "../images/img62.jpg";
// // import img26 from "../images/img80.jpg";
// // import img27 from "../images/new13.jpg";
// // import img28 from "../images/new14.jpg";
// // import img29 from "../images/new15.jpg";
// // import img30 from "../images/new17.jpg";
// // import img31 from "../images/new18.jpg";
// // import img32 from "../images/new22.jpg";
// // import img33 from "../images/new23.jpg";
// // import img34 from "../images/new24.jpg";
// // import img35 from "../images/new25.jpg";
// // import img36 from "../images/new26.jpg";


// // const folders = [
// //   {
// //     title: "ग्रंथालय उद्घाटन",
// //     rows: [
// //       {
// //         items: [
// //           { img: img1, paragraph: "ग्रंथालय उद्घाटनाचे मान्यवर श्री. चंद्रकांत दादा पाटील..." },
// //           { img: img2, paragraph: "माननीय डॉ. विनयरावजी कोरे (सावकर) यांचे आगमन..." },
// //           { img: img3, paragraph: "गोकुळ संचालक अमरसिंह पाटील भाऊ यांच्या हस्ते दीपप्रज्वलन..." }
// //         ]
// //       },
// //       {
// //         items: [
// //           { img: img4, paragraph: "सिने अभिनेते व प्रख्यात वक्ते श्री शरदजी पोंक्षे सर यांचे व्याख्यान..." },
// //           { img: img5, paragraph: "व्याख्यानाला उपस्थित असलेले श्रोते व नागरिक..." },
// //           { img: img6, paragraph: "वर्धापन दिनानिमित्त सावरकर विचारांवर चर्चा..." }
// //         ]
// //       }
// //     ]
// //   },
// //   {
// //     title: "ग्रंथालय पुरस्कार",
// //     rows: [
// //       {
// //         items: [
// //           { img: img7, paragraph: "ग्रंथालयाच्या उल्लेखनीय व उत्कृष्ट कार्याची दखल घेऊन Maharashtra शासन, मुंबई यांच्यामार्फत प्रतिष्ठित 'डॉ. बाबासाहेब आंबेडकर उत्कृष्ट ग्रंथालय' पुरस्काराने सन्मानित करण्यात आले आहे." },
// //           { img: img8, paragraph: "ग्रंथालयाला कोल्हापूर जिल्हा ग्रंथालय संघाच्या वतीने 'उत्कृष्ट ग्रंथालय पुरस्कार' प्रदान करून गौरविण्यात आले आहे." },
// //           { img: img9, paragraph: "ग्रंथालयाच्या समाजोपयोगी व उल्लेखनीय सेवेबद्दल कोडोली ग्रामपंचायतीच्या वतीनेही सन्मानित करण्यात आले आहे." }
// //         ]
// //       }
// //     ]
// //   },
// //   {
// //     title: "मान्यवरांच्या विशेष भेटी",
// //     rows: [
// //       {
// //         items: [
// //           { img: img10, paragraph: "ॐ चैतन्य गुरुमाऊली यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
// //           { img: img11, paragraph: "गुरुमाऊलींचे ग्रंथालयात स्वागत करताना व्यवस्थापक..." },
// //           { img: img12, paragraph: "ग्रंथालयाची पाहणी करताना पूज्य गुरुमाऊली..." }
// //         ]
// //       },
// //       {
// //         items: [
// //           { img: img13, paragraph:"राष्ट्रीय स्वयंसेवक संघाचे ज्येष्ठ प्रचारक आदरणीय मधुभाई कुलकर्णी यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
// //           { img: img14, paragraph:"माननीय खासदार श्री. धैर्यशीलजी माने यांनी ग्रंथालयाला भेट देऊन येथील अद्ययावत सुविधांची पाहणी केली व व्यवस्थापनाचे कौतुक केले." },
// //           { img: img15, paragraph:"डॉ. बाबासाहेब आंबेडकर टेक्नॉलॉजिकल युनिव्हर्सिटीचे माननीय कुलगुरू डॉ. कारभारी काळे सर आणि सौ. प्रज्ञा काळे मॅडम यांचे ग्रंथालयात शुभ आगमन झाले, त्यांनी ग्रंथालयातील विविध विभागांची पाहणी करून सदिच्छा भेट नोंदवली." }
// //         ]
// //       },
// //       {
// //         items: [
// //           { img: img27, paragraph: "जेष्ठ इतिहासकार व अर्थतज्ज्ञ आदरणीय डॉ. जे. के. पवार सर तसेच कोल्हापूर जिल्ह्याचे माहिती उपसंचालक आदरणीय श्री. टाके साहेब यांनी ग्रंथालयाला सदिच्छा भेट दिली."},
// //           { img: img28, paragraph: "राज्य ग्रंथालय संघाचे अध्यक्ष आदरणीय डॉ. गजानन कोटेवार जी यांची ग्रंथालयाला सदिच्छा भेट!"},
// //           { img: img29, paragraph: "प्रख्यात विचारवंत भारताचार्य गजानन बावन्नीकार आणि आदरणीय सु. ग. शेवडे गुरुजी यांची ग्रंथालयाला सदिच्छा भेट; ग्रंथालयातील ज्ञानसमृद्ध वातावरणाचे त्यांनी कौतुक केले." }
// //         ]
// //       },
// //        {
// //         items: [
// //           { img: img30, paragraph: "गोकुळचे संचालक, माजी शिक्षण सभापती व कोडोली जिल्हा परिषद सदस्य आदरणीय अमरसिंह पाटील (भाऊ) यांनी ग्रंथालयाला सदिच्छा भेट दिली."},
// //           { img: img31, paragraph: "माजी सभापती आदरणीय भारत पाटील (आप्पा) यांनी ग्रंथालयाला सदिच्छा भेट दिली."},
// //         ]
// //       }
// //     ]
// //   },
// //   {
// //     title: "ग्रंथालय विभाग",
// //     rows: [
// //       {
// //         items: [
// //           { img: img16, paragraph: "ग्रंथालय परिसर" },
// //           { img: img18, paragraph: "महिला विभाग" },
// //           { img: img19, paragraph: "वृत्तपत्र वाचन विभाग" },
// //           { img: img17, paragraph: "वर्तमानपत्र वाचन कक्ष व ऑफिस" },
// //         ]
// //       },
// //       {
// //         items: [
// //           { img: img33, paragraph: "स्पर्धा परीक्षा अभ्यासिका" },
// //           // { img: img34, paragraph: "महिला विभाग" },
// //           { img: img35, paragraph: "बाल  वभाग  " },
// //           { img: img36, paragraph: "ग्रंथालयाच्या बाहेरील दृश्य " },
// //         ]
// //       }
      
// //     ]
// //   },
// //   {
// //     title: "जुन्या आठवणी",
// //     rows: [
// //       {
// //         items: [
// //           { img: img20, paragraph: "पहिले जुने संस्मरण चित्र" },
// //           { img: img21, paragraph: "सुरुवातीच्या काळातील कार्यक्रम" },
// //           { img: img22, paragraph: "जुने सदस्य एकत्र असताना" },
// //           { img: img23, paragraph: "मागील काही वर्षांपूर्वीचे दृश्य" }
// //         ]
// //       },
// //       {
// //         items: [
// //           { img: img24, paragraph: "ग्रंथालयाच्या सुवर्णक्षणांची आठवण १" },
// //           { img: img25, paragraph: "ग्रंथालयाच्या सुवर्णक्षणांची आठवण २" },
// //           { img: img26, paragraph: "ग्रंथालयाच्या सुवर्णक्षणांची आठवण ३" }
// //         ]
// //       }
// //     ]
// //   },
// //   {
// //     title: "ग्रंथालयाचे यशस्वी विद्यार्थी",
// //     rows: [
// //       {
// //         items: [
// //           { img: img32, paragraph: "ग्रंथालयाच्या अभ्यासिकेतील विद्यार्थिनीची 'पुणे शहर पोलीस' पदी नियुक्ती!" },
          
// //         ]
// //       }
// //     ]
// //   }
// // ];

// // const FolderGallery = () => {
// //   const [openFolder, setOpenFolder] = useState(null);
// //   const [selectedImage, setSelectedImage] = useState(null);

// //   return (
// //     <section className="folder-gallery-section">
// //       <h2 className="gallery-title">“छायाचित्र संग्रह”</h2>

// //       {/* Grid */}
// //       <div className="folder-grid">
// //         {folders.map((folder, index) => (
// //           <div 
// //             key={index} 
// //             className={`folder-square-card ${openFolder === index ? "active" : ""}`}
// //             onClick={() => setOpenFolder(openFolder === index ? null : index)}
// //           >
// //             <div className="folder-icon-wrapper">
// //               <svg className="folder-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
// //                 <path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
// //               </svg>
// //             </div>
// //             <span className="folder-square-title">{folder.title}</span>
// //           </div>
// //         ))}
// //       </div>

// //       {/* folder section */}
// //       {openFolder !== null && (
// //         <div className="folder-content-drawer">
// //           <div className="drawer-header">
// //             <h3>📁 {folders[openFolder].title}</h3>
// //             <button className="drawer-close" onClick={() => setOpenFolder(null)}>बंद करा ✕</button>
// //           </div>
          
// //           <div className="folder-content">
// //             {folders[openFolder].rows.map((row, rowIndex) => (
// //               <div key={rowIndex} className="folder-row">
// //                 <div className="folder-items-grid">
// //                   {row.items.map((item, i) => (
// //                     <div key={i} className="gallery-item-block">
// //                       <div className="folder-image">
// //                         <img
// //                           src={item.img}
// //                           alt="gallery"
// //                           onClick={() => setSelectedImage(item.img)}
// //                         />
// //                       </div>
// //                       {item.paragraph && (
// //                         <p className="folder-paragraph">{item.paragraph}</p>
// //                       )}
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       )}

      
// //       {selectedImage && (
// //         <div className="image-modal" onClick={() => setSelectedImage(null)}>
// //           <button className="close-btn" onClick={() => setSelectedImage(null)}>
// //             ✕
// //           </button>
// //           <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
// //             <img src={selectedImage} alt="Focused View" className="modal-zoom-img" />
// //           </div>
// //         </div>
// //       )}
// //     </section>
// //   );
// // };

// // export default FolderGallery;




// import React, { useState } from "react";
// import "./FolderGallery.css";

// /* IMAGES */
// import img1 from "../images/img13.jpg";
// import img2 from "../images/img14.jpg";
// import img3 from "../images/img65.jpg";
// import img4 from "../images/img68.jpg";
// import img5 from "../images/img69.jpg";
// import img6 from "../images/new19.jpg";
// import img7 from "../images/new20.jpg";
// import img8 from "../images/img17.jpg";
// import img9 from "../images/new21.jpg";
// import img10 from "../images/new7.jpg";
// import img11 from "../images/new8.jpg";
// import img12 from "../images/new9.jpg";
// import img13 from "../images/new10.jpg";
// import img14 from "../images/new11.jpg";
// import img15 from "../images/new12.jpg";
// import img16 from "../images/img1.jpg";
// import img17 from "../images/img2.jpg";
// import img18 from "../images/img3.jpg";
// import img19 from "../images/img4.jpg";
// import img20 from "../images/img5.jpg";
// import img21 from "../images/img25.jpg";
// import img22 from "../images/img26.jpg";
// import img23 from "../images/img60.jpg";
// import img24 from "../images/img61.jpg";
// import img25 from "../images/img62.jpg";
// import img26 from "../images/img80.jpg";
// import img27 from "../images/new13.jpg";
// import img28 from "../images/new14.jpg";
// import img29 from "../images/new15.jpg";
// import img30 from "../images/new17.jpg";
// import img31 from "../images/new18.jpg";
// import img32 from "../images/new22.jpg";
// import img33 from "../images/new23.jpg";
// import img34 from "../images/new24.jpg";
// import img35 from "../images/new25.jpg";
// import img36 from "../images/new26.jpg";

// const folders = [
//   {
//     title: "ग्रंथालय उद्घाटन",
//     bgImage: img1, 
//     rows: [
//       {
//         items: [
//           { img: img1, paragraph: "ग्रंथालय उद्घाटनाचे मान्यवर श्री. चंद्रकांत दादा पाटील..." },
//           { img: img2, paragraph: "माननीय डॉ. विनयरावजी कोरे (सावकर) यांचे आगमन..." },
//           { img: img3, paragraph: "गोकुळ संचालक अमरसिंह पाटील भाऊ यांच्या हस्ते दीपप्रज्वलन..." }
//         ]
//       },
//       {
//         items: [
//           { img: img4, paragraph: "सिने अभिनेते व प्रख्यात वक्ते श्री शरदजी पोंक्षे सर यांचे व्याख्यान..." },
//           { img: img5, paragraph: "व्याख्यानाला उपस्थित असलेले श्रोते व नागरिक..." },
//           { img: img6, paragraph: "वर्धापन दिनानिमित्त सावरकर विचारांवर चर्चा..." }
//         ]
//       }
//     ]
//   },
//   {
//     title: "ग्रंथालय पुरस्कार",
//     bgImage: img7, 
//     rows: [
//       {
//         items: [
//           { img: img7, paragraph: "ग्रंथालयाच्या उल्लेखनीय व उत्कृष्ट कार्याची दखल घेऊन Maharashtra शासन, मुंबई यांच्यामार्फत प्रतिष्ठित 'डॉ. बाबासाहेब आंबेडकर उत्कृष्ट ग्रंथालय' पुरस्काराने सन्मानित करण्यात आले आहे." },
//           { img: img8, paragraph: "ग्रंथालयाला कोल्हापूर जिल्हा ग्रंथालय संघाच्या वतीने 'उत्कृष्ट ग्रंथालय पुरस्कार' प्रदान करून गौरविण्यात आले आहे." },
//           { img: img9, paragraph: "ग्रंथालयाच्या समाजोपयोगी व उल्लेखनीय सेवेबद्दल कोडोली ग्रामपंचायतीच्या वतीनेही सन्मानित करण्यात आले आहे." }
//         ]
//       }
//     ]
//   },
//   {
//     title: "मान्यवरांच्या विशेष भेटी",
//     bgImage: img10, 
//     rows: [
//       {
//         items: [
//           { img: img10, paragraph: "ॐ चैतन्य गुरुमाऊली यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
//           { img: img11, paragraph: "गुरुमाऊलींचे ग्रंथालयात स्वागत करताना व्यवस्थापक..." },
//           { img: img12, paragraph: "ग्रंथालयाची पाहणी करताना पूज्य गुरुमाऊली..." }
//         ]
//       },
//       {
//         items: [
//           { img: img13, paragraph: "राष्ट्रीय स्वयंसेवक संघाचे ज्येष्ठ प्रचारक आदरणीय मधुभाई कुलकर्णी यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
//           { img: img14, paragraph: "माननीय खासदार श्री. धैर्यशीलजी माने यांनी ग्रंथालयाला भेट देऊन येथील अद्ययावत सुविधांची पाहणी केली व व्यवस्थापनाचे कौतुक केले." },
//           { img: img15, paragraph: "डॉ. बाबासाहेब आंबेडकर टेक्नॉलॉजिकल युनिव्हर्सिटीचे माननीय कुलगुरू डॉ. कारभारी काळे सर आणि सौ. प्रज्ञा काळे मॅडम यांचे ग्रंथालयात शुभ आगमन झाले, त्यांनी ग्रंथालयातील विविध विभागांची पाहणी करून सदिच्छा भेट नोंदवली." }
//         ]
//       },
//       {
//         items: [
//           { img: img27, paragraph: "जेष्ठ इतिहासकार व अर्थतज्ज्ञ आदरणीय डॉ. जे. के. पवार सर तसेच कोल्हापूर जिल्ह्याचे माहिती उपसंचालक आदरणीय श्री. टाके साहेब यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
//           { img: img28, paragraph: "राज्य ग्रंथालय संघाचे अध्यक्ष आदरणीय डॉ. गजानन कोटेवार जी यांची ग्रंथालयाला सदिच्छा भेट!" },
//           { img: img29, paragraph: "प्रख्यात विचारवंत भारताचार्य गजानन बावन्नीकार आणि आदरणीय सु. ग. शेवडे गुरुजी यांची ग्रंथालयाला सदिच्छा भेट; ग्रंथालयातील ज्ञानसमृद्ध वातावरणाचे त्यांनी कौतुक केले." }
//         ]
//       },
//       {
//         items: [
//           { img: img30, paragraph: "गोकुळचे संचालक, माजी शिक्षण सभापती व कोडोली जिल्हा परिषद सदस्य आदरणीय अमरसिंह पाटील (भाऊ) यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
//           { img: img31, paragraph: "माजी सभापती आदरणीय भारत पाटील (आप्पा) यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
//         ]
//       }
//     ]
//   },
//   {
//     title: "ग्रंथालय विभाग",
//     bgImage: img16, 
//     rows: [
//       {
//         items: [
//           { img: img16, paragraph: "ग्रंथालय परिसर" },
//           { img: img18, paragraph: "महिला विभाग" },
//           { img: img19, paragraph: "वृत्तपत्र वाचन विभाग" },
//           { img: img17, paragraph: "वर्तमानपत्र वाचन कक्ष व ऑफिस" },
//         ]
//       },
//       {
//         items: [
//           { img: img33, paragraph: "स्पर्धा परीक्षा अभ्यासिका" },
//           { img: img35, paragraph: "बाल  वभाग  " },
//           { img: img36, paragraph: "ग्रंथालयाच्या बाहेरील दृश्य " },
//         ]
//       }

//     ]
//   },
//   {
//     title: "जुन्या आठवणी",
//     bgImage: img20, 
//     rows: [
//       {
//         items: [
//           { img: img20, paragraph: "पहिले जुने संस्मरण चित्र" },
//           { img: img21, paragraph: "सुरुवातीच्या काळातील कार्यक्रम" },
//           { img: img22, paragraph: "जुने सदस्य एकत्र असताना" },
//           { img: img23, paragraph: "मागील काही वर्षांपूर्वीचे दृश्य" }
//         ]
//       },
//       {
//         items: [
//           { img: img24, paragraph: "ग्रंथालयाच्या सुवर्णक्षणांची आठवण १" },
//           { img: img25, paragraph: "ग्रंथालयाच्या सुवर्णक्षणांची आठवण २" },
//           { img: img26, paragraph: "ग्रंथालयाच्या सुवर्णक्षणांची आठवण ३" }
//         ]
//       }
//     ]
//   },
//   {
//     title: "ग्रंथालयाचे यशस्वी विद्यार्थी",
//     bgImage: img32, 
//     rows: [
//       {
//         items: [
//           { img: img32, paragraph: "ग्रंथालयाच्या अभ्यासिकेतील विद्यार्थिनीची 'पुणे शहर पोलीस' पदी नियुक्ती!" },

//         ]
//       }
//     ]
//   }
// ];

// const FolderGallery = () => {
//   const [openFolder, setOpenFolder] = useState(null);
//   const [selectedImage, setSelectedImage] = useState(null);

//   return (
//     <section className="folder-gallery-section">
//       <h2 className="gallery-title">“छायाचित्र संग्रह”</h2>

//       {/* Grid */}
//       <div className="folder-grid">
//         {folders.map((folder, index) => {
//           const isBackgroundActive = openFolder === index;
//           const overlayColor = isBackgroundActive 
//             ? "linear-gradient(rgba(122, 0, 0, 0.85), rgba(122, 0, 0, 0.85))" 
//             : "linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.55))";

//           return (
//             <div
//               key={index}
//               className={`folder-square-card ${isBackgroundActive ? "active" : ""}`}
//               onClick={() => setOpenFolder(isBackgroundActive ? null : index)}
//               style={{
//                 backgroundImage: `${overlayColor}, url(${folder.bgImage})`
//               }}
//             >
//               <div className="folder-icon-wrapper">
//                 <svg className="folder-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                   <path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
//                 </svg>
//               </div>
//               <span className="folder-square-title">{folder.title}</span>
//             </div>
//           );
//         })}
//       </div>

//       {/* folder section */}
//       {openFolder !== null && (
//         <div className="folder-content-drawer">
//           <div className="drawer-header">
//             <h3>📁 {folders[openFolder].title}</h3>
//             <button className="drawer-close" onClick={() => setOpenFolder(null)}>बंद करा ✕</button>
//           </div>

//           <div className="folder-content">
//             {folders[openFolder].rows.map((row, rowIndex) => (
//               <div key={rowIndex} className="folder-row">
//                 <div className="folder-items-grid">
//                   {row.items.map((item, i) => (
//                     <div key={i} className="gallery-item-block">
//                       <div className="folder-image">
//                         <img
//                           src={item.img}
//                           alt="gallery"
//                           onClick={() => setSelectedImage(item.img)}
//                         />
//                       </div>
//                       {item.paragraph && (
//                         <p className="folder-paragraph">{item.paragraph}</p>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}


//       {selectedImage && (
//         <div className="image-modal" onClick={() => setSelectedImage(null)}>
//           <button className="close-btn" onClick={() => setSelectedImage(null)}>
//             ✕
//           </button>
//           <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
//             <img src={selectedImage} alt="Focused View" className="modal-zoom-img" />
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default FolderGallery;









import React, { useState, useEffect, useRef } from "react";
import "./FolderGallery.css";

/* IMAGES */
import img1 from "../images/img13.jpg";
import img2 from "../images/img14.jpg";
import img3 from "../images/img65.jpg";
import img4 from "../images/img68.jpg";
import img5 from "../images/img69.jpg";
import img6 from "../images/new19.jpg";
import img7 from "../images/new20.jpg";
import img8 from "../images/img17.jpg";
import img9 from "../images/new21.jpg";
import img10 from "../images/new7.jpg";
import img11 from "../images/new8.jpg";
import img12 from "../images/new9.jpg";
import img13 from "../images/new10.jpg";
import img14 from "../images/new11.jpg";
import img15 from "../images/new12.jpg";
import img16 from "../images/img1.jpg";
import img17 from "../images/img2.jpg";
import img18 from "../images/img3.jpg";
import img19 from "../images/img4.jpg";
import img20 from "../images/img5.jpg";
import img21 from "../images/img25.jpg";
import img22 from "../images/img26.jpg";
import img23 from "../images/img60.jpg";
import img24 from "../images/img61.jpg";
import img25 from "../images/img62.jpg";
import img26 from "../images/img80.jpg";
import img27 from "../images/new13.jpg";
import img28 from "../images/new14.jpg";
import img29 from "../images/new15.jpg";
import img30 from "../images/new17.jpg";
import img31 from "../images/new18.jpg";
import img32 from "../images/new22.jpg";
import img33 from "../images/new23.jpg";
import img34 from "../images/new24.jpg";
import img35 from "../images/new25.jpg";
import img36 from "../images/new26.jpg";

const folders = [
  {
    title: "ग्रंथालय उद्घाटन",
    bgImage: img1, 
    rows: [
      {
        items: [
          { img: img1, paragraph: "ग्रंथालय उद्घाटनाचे मान्यवर श्री. चंद्रकांत दादा पाटील..." },
          { img: img2, paragraph: "माननीय डॉ. विनयरावजी कोरे (सावकर) यांचे आगमन..." },
          { img: img3, paragraph: "गोकुळ संचालक अमरसिंह पाटील भाऊ यांच्या हस्ते दीपप्रज्वलन..." }
        ]
      },
      {
        items: [
          { img: img4, paragraph: "सिने अभिनेते व प्रख्यात वक्ते श्री शरदजी पोंक्षे सर यांचे व्याख्यान..." },
          { img: img5, paragraph: "व्याख्यानाला उपस्थित असलेले श्रोते व नागरिक..." },
          { img: img6, paragraph: "वर्धापन दिनानिमित्त सावरकर विचारांवर चर्चा..." }
        ]
      }
    ]
  },
  {
    title: "ग्रंथालय पुरस्कार",
    bgImage: img7, 
    rows: [
      {
        items: [
          { img: img7, paragraph: "ग्रंथालयाच्या उल्लेखनीय व उत्कृष्ट कार्याची दखल घेऊन Maharashtra शासन, मुंबई यांच्यामार्फत प्रतिष्ठित 'डॉ. बाबासाहेब आंबेडकर उत्कृष्ट ग्रंथालय' पुरस्काराने सन्मानित करण्यात आले आहे." },
          { img: img8, paragraph: "ग्रंथालयाला कोल्हापूर जिल्हा ग्रंथालय संघाच्या वतीने 'उत्कृष्ट ग्रंथालय पुरस्कार' प्रदान करून गौरविण्यात आले आहे." },
          { img: img9, paragraph: "ग्रंथालयाच्या समाजोपयोगी व उल्लेखनीय सेवेबद्दल कोडोली ग्रामपंचायतीच्या वतीनेही सन्मानित करण्यात आले आहे." }
        ]
      }
    ]
  },
  {
    title: "मान्यवरांच्या विशेष भेटी",
    bgImage: img10, 
    rows: [
      {
        items: [
          { img: img10, paragraph: "ॐ चैतन्य गुरुमाऊली यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
          { img: img11, paragraph: "गुरुमाऊलींचे ग्रंथालयात स्वागत करताना व्यवस्थापक..." },
          { img: img12, paragraph: "ग्रंथालयाची पाहणी करताना पूज्य गुरुमाऊली..." }
        ]
      },
      {
        items: [
          { img: img13, paragraph: "राष्ट्रीय स्वयंसेवक संघाचे ज्येष्ठ प्रचारक आदरणीय मधुभाई कुलकर्णी यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
          { img: img14, paragraph: "माननीय खासदार श्री. धैर्यशीलजी माने यांनी ग्रंथालयाला भेट देऊन येथील अद्ययावत सुविधांची पाहणी केली व व्यवस्थापनाचे कौतुक केले." },
          { img: img15, paragraph: "डॉ. बाबासाहेब आंबेडकर टेक्नॉलॉजिकल युनिव्हर्सिटीचे माननीय कुलगुरू डॉ. कारभारी काळे सर आणि सौ. प्रज्ञा काळे मॅडम यांचे ग्रंथालयात शुभ आगमन झाले, त्यांनी ग्रंथालयातील विविध विभागांची पाहणी करून सदिच्छा भेट नोंदवली." }
        ]
      },
      {
        items: [
          { img: img27, paragraph: "जेष्ठ इतिहासकार व अर्थतज्ज्ञ आदरणीय डॉ. जे. के. पवार सर तसेच कोल्हापूर जिल्ह्याचे माहिती उपसंचालक आदरणीय श्री. टाके साहेब यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
          { img: img28, paragraph: "राज्य ग्रंथालय संघाचे अध्यक्ष आदरणीय डॉ. गजानन कोटेवार जी यांची ग्रंथालयाला सदिच्छा भेट!" },
          { img: img29, paragraph: "प्रख्यात विचारवंत भारताचार्य गजानन बावन्नीकार आणि आदरणीय सु. ग. शेवडे गुरुजी यांची ग्रंथालयाला सदिच्छा भेट; ग्रंथालयातील ज्ञानसमृद्ध वातावरणाचे त्यांनी कौतुक केले." }
        ]
      },
      {
        items: [
          { img: img30, paragraph: "गोकुळचे संचालक, माजी शिक्षण सभापती व कोडोली जिल्हा परिषद सदस्य आदरणीय अमरसिंह पाटील (भाऊ) यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
          { img: img31, paragraph: "माजी सभापती आदरणीय भारत पाटील (आप्पा) यांनी ग्रंथालयाला सदिच्छा भेट दिली." },
        ]
      }
    ]
  },
  {
    title: "ग्रंथालय विभाग",
    bgImage: img16, 
    rows: [
      {
        items: [
          { img: img16, paragraph: "ग्रंथालय परिसर" },
          { img: img18, paragraph: "महिला विभाग" },
          { img: img19, paragraph: "वृत्तपत्र वाचन विभाग" },
          { img: img17, paragraph: "वर्तमानपत्र वाचन कक्ष व ऑफिस" },
        ]
      },
      {
        items: [
          { img: img33, paragraph: "स्पर्धा परीक्षा अभ्यासिका" },
          { img: img35, paragraph: "बाल  विभाग  " },
          { img: img36, paragraph: "ग्रंथालयाच्या बाहेरील दृश्य " },
        ]
      }
    ]
  },
  {
    title: "जुन्या आठवणी",
    bgImage: img20, 
    rows: [
      {
        items: [
          { img: img20, paragraph: "पहिले जुने संस्मरण चित्र" },
          { img: img21, paragraph: "सुरुवातीच्या काळातील कार्यक्रम" },
          { img: img22, paragraph: "जुने सदस्य एकत्र असताना" },
          { img: img23, paragraph: "मागील काही वर्षांपूर्वीचे दृश्य" }
        ]
      },
      {
        items: [
          { img: img24, paragraph: "ग्रंथालयाच्या सुवर्णक्षणांची आठवण १" },
          { img: img25, paragraph: "ग्रंथालयाच्या सुवर्णक्षणांची आठवण २" },
          { img: img26, paragraph: "ग्रंथालयाच्या सुवर्णक्षणांची आठवण ३" }
        ]
      }
    ]
  },
  {
    title: "ग्रंथालयाचे यशस्वी विद्यार्थी",
    bgImage: img32, 
    rows: [
      {
        items: [
          { img: img32, paragraph: "ग्रंथालयाच्या अभ्यासिकेतील विद्यार्थिनीची 'पुणे शहर पोलीस' पदी नियुक्ती!" },
        ]
      }
    ]
  }
];

const FolderGallery = () => {
  const [openFolder, setOpenFolder] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const drawerRef = useRef(null);

  useEffect(() => {
    if (openFolder !== null && drawerRef.current) {
      setTimeout(() => {
        drawerRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 100);
    }
  }, [openFolder]);

  return (
    <section className="folder-gallery-section">
      <h2 className="gallery-title">“छायाचित्र संग्रह”</h2>

      {/* Grid */}
      <div className="folder-grid">
        {folders.map((folder, index) => {
          const isBackgroundActive = openFolder === index;
          const overlayColor = isBackgroundActive 
            ? "linear-gradient(rgba(122, 0, 0, 0.85), rgba(122, 0, 0, 0.85))" 
            : "linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.55))";

          return (
            <div
              key={index}
              className={`folder-square-card ${isBackgroundActive ? "active" : ""}`}
              onClick={() => setOpenFolder(isBackgroundActive ? null : index)}
              style={{
                backgroundImage: `${overlayColor}, url(${folder.bgImage})`
              }}
            >
              <div className="folder-icon-wrapper">
                <svg className="folder-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
                </svg>
              </div>
              <span className="folder-square-title">{folder.title}</span>
            </div>
          );
        })}
      </div>

      {/* folder section */}
      {openFolder !== null && (
        <div ref={drawerRef} className="folder-content-drawer">
          <div className="drawer-header">
            <h3>📁 {folders[openFolder].title}</h3>
            <button className="drawer-close" onClick={() => setOpenFolder(null)}>बंद करा ✕</button>
          </div>

          <div className="folder-content">
            {folders[openFolder].rows.map((row, rowIndex) => (
              <div key={rowIndex} className="folder-row">
                <div className="folder-items-grid">
                  {row.items.map((item, i) => (
                    <div key={i} className="gallery-item-block">
                      <div className="folder-image">
                        <img
                          src={item.img}
                          alt="gallery"
                          onClick={() => setSelectedImage(item.img)}
                        />
                      </div>
                      {item.paragraph && (
                        <p className="folder-paragraph">{item.paragraph}</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <button className="close-btn" onClick={() => setSelectedImage(null)}>
            ✕
          </button>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Focused View" className="modal-zoom-img" />
          </div>
        </div>
      )}
    </section>
  );
};

export default FolderGallery;